const ecoscanMockData = {
  lineChart: {
    overview: {
      transactionCount: [
        {
          date: "2024-12-31",
          yungtestworkspace3: 1479,
          jeff: 22,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-01",
          yungtestworkspace3: 467,
          jeff: 12,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-02",
          yungtestworkspace3: 96,
          jeff: 18,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-03",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-04",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-05",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
        {
          date: "2025-01-06",
          yungtestworkspace3: 0,
          jeff: 0,
          yungtestworkspace4: "N/A",
          yungtestworkspace5: "N/A",
          ethan: "-",
        },
      ],
    },
    community: {
      newDiscordMember: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 46,
          yungtestworkspace5: 40,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 35,
          yungtestworkspace5: 27,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 14,
          yungtestworkspace5: 31,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 23,
          yungtestworkspace5: 49,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 48,
          yungtestworkspace5: 20,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 45,
          yungtestworkspace5: 23,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 21,
          yungtestworkspace5: 26,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 45,
          yungtestworkspace5: 40,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 27,
          yungtestworkspace5: 32,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 10,
          yungtestworkspace5: 16,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 37,
          yungtestworkspace5: 21,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 42,
          yungtestworkspace5: 39,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 22,
          yungtestworkspace5: 24,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 27,
          yungtestworkspace5: 31,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 29,
          yungtestworkspace5: 28,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 13,
          yungtestworkspace5: 34,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 24,
          yungtestworkspace5: 10,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 45,
          yungtestworkspace5: 29,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 16,
          yungtestworkspace5: 14,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 22,
          yungtestworkspace5: 43,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 50,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 21,
          yungtestworkspace5: 41,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 15,
          yungtestworkspace5: 12,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
      newTelegramMember: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 47,
          yungtestworkspace5: 23,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 10,
          yungtestworkspace5: 32,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 28,
          yungtestworkspace5: 27,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 25,
          yungtestworkspace5: 19,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 13,
          yungtestworkspace5: 35,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 50,
          yungtestworkspace5: 15,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 32,
          yungtestworkspace5: 26,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 23,
          yungtestworkspace5: 14,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 50,
          yungtestworkspace5: 37,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 24,
          yungtestworkspace5: 35,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 38,
          yungtestworkspace5: 19,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 27,
          yungtestworkspace5: 16,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 27,
          yungtestworkspace5: 41,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 18,
          yungtestworkspace5: 49,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 35,
          yungtestworkspace5: 26,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 25,
          yungtestworkspace5: 24,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 46,
          yungtestworkspace5: 15,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 40,
          yungtestworkspace5: 48,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 47,
          yungtestworkspace5: 17,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 47,
          yungtestworkspace5: 22,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 42,
          yungtestworkspace5: 19,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 44,
          yungtestworkspace5: 30,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 36,
          yungtestworkspace5: 22,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
      engagementRate: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 2.3516237402015676,
          yungtestworkspace5: 2.068045363575717,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 2.3861967694566815,
          yungtestworkspace5: 2.5842329080798168,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 2.4945770065075923,
          yungtestworkspace5: 2.3434991974317816,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 2.700781805259417,
          yungtestworkspace5: 2.7332704995287465,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 2.5391304347826087,
          yungtestworkspace5: 2.316244595429277,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 2.5925925925925926,
          yungtestworkspace5: 1.8925518925518925,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 2.150181938471717,
          yungtestworkspace5: 2.0733173076923075,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 2.4587512131996117,
          yungtestworkspace5: 1.8628030751034892,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 2.5883838383838382,
          yungtestworkspace5: 1.8255578093306288,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 2.5608994378513428,
          yungtestworkspace5: 1.856082238720731,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 1.9530057979859627,
          yungtestworkspace5: 2.2868435911914173,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 2.121936640765093,
          yungtestworkspace5: 1.8070614400889629,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 1.826215022091311,
          yungtestworkspace5: 2.184598580010923,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 2.0930232558139537,
          yungtestworkspace5: 1.7103153393907,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 2.026255707762557,
          yungtestworkspace5: 1.4488935721812435,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 1.7504234895539243,
          yungtestworkspace5: 1.5568240788790866,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 2.131782945736434,
          yungtestworkspace5: 2.088167053364269,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 2.1909656478225585,
          yungtestworkspace5: 1.5419615773508595,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 1.5159574468085106,
          yungtestworkspace5: 1.9563581640331076,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 1.8803865238965787,
          yungtestworkspace5: 1.826258637709773,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 1.810762560571283,
          yungtestworkspace5: 1.7228827954380004,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 1.6808830908178627,
          yungtestworkspace5: 2.075381679389313,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 0.4458756502353232,
          yungtestworkspace5: 0.5205868433506862,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
      "Retention Rate": [
        {
          date: "2024-12-08",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 76.59574468085107,
          yungtestworkspace5: 65,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 62.857142857142854,
          yungtestworkspace5: 78.125,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 67.85714285714286,
          yungtestworkspace5: 77.41935483870968,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 76,
          yungtestworkspace5: 63.26530612244898,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 60.416666666666664,
          yungtestworkspace5: 65.71428571428571,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 82,
          yungtestworkspace5: 73.91304347826086,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 71.875,
          yungtestworkspace5: 65.38461538461539,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 68.88888888888889,
          yungtestworkspace5: 62.5,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 64,
          yungtestworkspace5: 75.67567567567568,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 66.66666666666666,
          yungtestworkspace5: 62.857142857142854,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 76.31578947368422,
          yungtestworkspace5: 76.19047619047619,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 66.66666666666666,
          yungtestworkspace5: 61.53846153846154,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 70.37037037037037,
          yungtestworkspace5: 65.85365853658537,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 66.66666666666666,
          yungtestworkspace5: 73.46938775510205,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 77.14285714285715,
          yungtestworkspace5: 71.42857142857143,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 64,
          yungtestworkspace5: 73.52941176470588,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 69.56521739130434,
          yungtestworkspace5: 80,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 71.11111111111111,
          yungtestworkspace5: 66.66666666666666,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 61.702127659574465,
          yungtestworkspace5: 64.70588235294117,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 68.08510638297872,
          yungtestworkspace5: 65.11627906976744,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 78,
          yungtestworkspace5: 68.42105263157895,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: "N/A",
        },
      ],
    },
    websiteTraffic: {
      sessionCount: [
        {
          date: "2024/12/08",
          yungtestworkspace5: 10,
          yungtestworkspace4: 9,
          yungtestworkspace3: 33,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/09",
          yungtestworkspace5: 10,
          yungtestworkspace4: 10,
          yungtestworkspace3: 32,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/10",
          yungtestworkspace5: 10,
          yungtestworkspace4: 9,
          yungtestworkspace3: 27,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/11",
          yungtestworkspace5: 11,
          yungtestworkspace4: 10,
          yungtestworkspace3: 32,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/12",
          yungtestworkspace5: 9,
          yungtestworkspace4: 10,
          yungtestworkspace3: 30,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/13",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 33,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/14",
          yungtestworkspace5: 10,
          yungtestworkspace4: 11,
          yungtestworkspace3: 30,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/15",
          yungtestworkspace5: 11,
          yungtestworkspace4: 11,
          yungtestworkspace3: 32,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/16",
          yungtestworkspace5: 10,
          yungtestworkspace4: 10,
          yungtestworkspace3: 28,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/17",
          yungtestworkspace5: 10,
          yungtestworkspace4: 10,
          yungtestworkspace3: 32,
          jeff: 2,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/18",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 33,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/19",
          yungtestworkspace5: 10,
          yungtestworkspace4: 11,
          yungtestworkspace3: 32,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/20",
          yungtestworkspace5: 11,
          yungtestworkspace4: 10,
          yungtestworkspace3: 29,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/21",
          yungtestworkspace5: 10,
          yungtestworkspace4: 9,
          yungtestworkspace3: 29,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/22",
          yungtestworkspace5: 10,
          yungtestworkspace4: 11,
          yungtestworkspace3: 31,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/23",
          yungtestworkspace5: 10,
          yungtestworkspace4: 11,
          yungtestworkspace3: 30,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/24",
          yungtestworkspace5: 11,
          yungtestworkspace4: 10,
          yungtestworkspace3: 29,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/25",
          yungtestworkspace5: 11,
          yungtestworkspace4: 11,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/26",
          yungtestworkspace5: 10,
          yungtestworkspace4: 10,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/27",
          yungtestworkspace5: 9,
          yungtestworkspace4: 10,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/28",
          yungtestworkspace5: 11,
          yungtestworkspace4: 10,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/29",
          yungtestworkspace5: 10,
          yungtestworkspace4: 9,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/30",
          yungtestworkspace5: 11,
          yungtestworkspace4: 11,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/31",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2025/01/01",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2025/01/02",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 2,
        },
        {
          date: "2025/01/03",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/04",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/05",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/06",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
      ],
      "Wallet Count": [
        {
          date: "2024/12/08",
          yungtestworkspace5: 10,
          yungtestworkspace4: 9,
          yungtestworkspace3: 33,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/09",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 7,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/10",
          yungtestworkspace5: 9,
          yungtestworkspace4: 8,
          yungtestworkspace3: 6,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/11",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 7,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/12",
          yungtestworkspace5: 8,
          yungtestworkspace4: 9,
          yungtestworkspace3: 6,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/13",
          yungtestworkspace5: 8,
          yungtestworkspace4: 8,
          yungtestworkspace3: 7,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/14",
          yungtestworkspace5: 9,
          yungtestworkspace4: 10,
          yungtestworkspace3: 6,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/15",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 7,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/16",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 6,
          jeff: "N/A",
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/17",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 7,
          jeff: 1,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/18",
          yungtestworkspace5: 8,
          yungtestworkspace4: 8,
          yungtestworkspace3: 7,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/19",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 7,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/20",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 6,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/21",
          yungtestworkspace5: 9,
          yungtestworkspace4: 8,
          yungtestworkspace3: 6,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/22",
          yungtestworkspace5: 9,
          yungtestworkspace4: 10,
          yungtestworkspace3: 7,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/23",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 6,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/24",
          yungtestworkspace5: 10,
          yungtestworkspace4: 9,
          yungtestworkspace3: 6,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/25",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/26",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/27",
          yungtestworkspace5: 8,
          yungtestworkspace4: 9,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/28",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/29",
          yungtestworkspace5: 9,
          yungtestworkspace4: 8,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/30",
          yungtestworkspace5: 9,
          yungtestworkspace4: 9,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2024/12/31",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2025/01/01",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: "N/A",
        },
        {
          date: "2025/01/02",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 1,
        },
        {
          date: "2025/01/03",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/04",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/05",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/06",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
      ],
      "Retention Rate": [
        {
          date: "2024/12/08",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 12.5,
          yungtestworkspace3: 71.42857142857143,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/09",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 71.42857142857143,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/10",
          yungtestworkspace5: 22.22222222222222,
          yungtestworkspace4: 12.5,
          yungtestworkspace3: 83.33333333333334,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/11",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 85.71428571428571,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/12",
          yungtestworkspace5: 12.5,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 100,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/13",
          yungtestworkspace5: 12.5,
          yungtestworkspace4: 12.5,
          yungtestworkspace3: 100,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/14",
          yungtestworkspace5: 22.22222222222222,
          yungtestworkspace4: 20,
          yungtestworkspace3: 100,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/15",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 71.42857142857143,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/16",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 100,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/17",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 85.71428571428571,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/18",
          yungtestworkspace5: 12.5,
          yungtestworkspace4: 25,
          yungtestworkspace3: 71.42857142857143,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/19",
          yungtestworkspace5: 22.22222222222222,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 85.71428571428571,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/20",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 83.33333333333334,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/21",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 12.5,
          yungtestworkspace3: 100,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/22",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 20,
          yungtestworkspace3: 85.71428571428571,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/23",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 83.33333333333334,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/24",
          yungtestworkspace5: 20,
          yungtestworkspace4: 22.22222222222222,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/25",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/26",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/27",
          yungtestworkspace5: 25,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/28",
          yungtestworkspace5: 11.11111111111111,
          yungtestworkspace4: 11.11111111111111,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/29",
          yungtestworkspace5: 22.22222222222222,
          yungtestworkspace4: 25,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/30",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2024/12/31",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/01",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/02",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/03",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/04",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/05",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
        {
          date: "2025/01/06",
          yungtestworkspace5: 0,
          yungtestworkspace4: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          morphgranttrackingdashboardtest1231: 0,
        },
      ],
    },
    dAppTracking: {
      "Wallet Count": [
        {
          date: "2024-12-08",
          yungtestworkspace4: 382,
          yungtestworkspace5: 372,
          yungtestworkspace3: "N/A",
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 371,
          yungtestworkspace5: 376,
          yungtestworkspace3: 1,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 358,
          yungtestworkspace5: 362,
          yungtestworkspace3: 3,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 364,
          yungtestworkspace5: 359,
          yungtestworkspace3: 1,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 380,
          yungtestworkspace5: 361,
          yungtestworkspace3: 4,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 357,
          yungtestworkspace5: 354,
          yungtestworkspace3: 3,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 361,
          yungtestworkspace5: 337,
          yungtestworkspace3: 3,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 328,
          yungtestworkspace5: 328,
          yungtestworkspace3: 4,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 366,
          yungtestworkspace5: 354,
          yungtestworkspace3: 3,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 355,
          yungtestworkspace5: 347,
          yungtestworkspace3: 3,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 353,
          yungtestworkspace5: 351,
          yungtestworkspace3: 11,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 365,
          yungtestworkspace5: 363,
          yungtestworkspace3: 18,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 336,
          yungtestworkspace5: 330,
          yungtestworkspace3: 19,
          jeff: 5,
          ethan: "-",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 307,
          yungtestworkspace5: 280,
          yungtestworkspace3: 44,
          jeff: 43,
          ethan: "-",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 333,
          yungtestworkspace5: 292,
          yungtestworkspace3: 92,
          jeff: 63,
          ethan: "-",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 360,
          yungtestworkspace5: 315,
          yungtestworkspace3: 86,
          jeff: 71,
          ethan: "-",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 342,
          yungtestworkspace5: 347,
          yungtestworkspace3: 123,
          jeff: 105,
          ethan: "-",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 348,
          yungtestworkspace5: 375,
          yungtestworkspace3: 272,
          jeff: 273,
          ethan: "-",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 393,
          yungtestworkspace5: 348,
          yungtestworkspace3: 331,
          jeff: 239,
          ethan: "-",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 320,
          yungtestworkspace5: 285,
          yungtestworkspace3: 304,
          jeff: 237,
          ethan: "-",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 259,
          yungtestworkspace5: 265,
          yungtestworkspace3: 261,
          jeff: 184,
          ethan: "-",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 252,
          yungtestworkspace5: 290,
          yungtestworkspace3: 240,
          jeff: 152,
          ethan: "-",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 248,
          yungtestworkspace5: 228,
          yungtestworkspace3: 209,
          jeff: 143,
          ethan: "-",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 1261,
          jeff: 22,
          ethan: "-",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 382,
          jeff: 12,
          ethan: "-",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 80,
          jeff: 17,
          ethan: "-",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
      ],
      transactionCount: [
        {
          date: "2024-12-08",
          yungtestworkspace4: 420,
          yungtestworkspace5: 420,
          yungtestworkspace3: "N/A",
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 415,
          yungtestworkspace5: 418,
          yungtestworkspace3: 1,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 398,
          yungtestworkspace5: 396,
          yungtestworkspace3: 4,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 413,
          yungtestworkspace5: 400,
          yungtestworkspace3: 1,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 427,
          yungtestworkspace5: 402,
          yungtestworkspace3: 4,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 386,
          yungtestworkspace5: 398,
          yungtestworkspace3: 4,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 384,
          yungtestworkspace5: 366,
          yungtestworkspace3: 3,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 370,
          yungtestworkspace5: 360,
          yungtestworkspace3: 5,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 411,
          yungtestworkspace5: 399,
          yungtestworkspace3: 11,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 402,
          yungtestworkspace5: 380,
          yungtestworkspace3: 4,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 383,
          yungtestworkspace5: 386,
          yungtestworkspace3: 16,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 398,
          yungtestworkspace5: 422,
          yungtestworkspace3: 41,
          jeff: "N/A",
          ethan: "-",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 380,
          yungtestworkspace5: 367,
          yungtestworkspace3: 26,
          jeff: 5,
          ethan: "-",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 341,
          yungtestworkspace5: 318,
          yungtestworkspace3: 55,
          jeff: 45,
          ethan: "-",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 370,
          yungtestworkspace5: 327,
          yungtestworkspace3: 96,
          jeff: 70,
          ethan: "-",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 402,
          yungtestworkspace5: 354,
          yungtestworkspace3: 91,
          jeff: 72,
          ethan: "-",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 379,
          yungtestworkspace5: 399,
          yungtestworkspace3: 141,
          jeff: 106,
          ethan: "-",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 390,
          yungtestworkspace5: 409,
          yungtestworkspace3: 316,
          jeff: 288,
          ethan: "-",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 435,
          yungtestworkspace5: 382,
          yungtestworkspace3: 398,
          jeff: 251,
          ethan: "-",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 353,
          yungtestworkspace5: 318,
          yungtestworkspace3: 358,
          jeff: 250,
          ethan: "-",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 289,
          yungtestworkspace5: 281,
          yungtestworkspace3: 303,
          jeff: 192,
          ethan: "-",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 283,
          yungtestworkspace5: 318,
          yungtestworkspace3: 316,
          jeff: 156,
          ethan: "-",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 260,
          yungtestworkspace5: 238,
          yungtestworkspace3: 250,
          jeff: 149,
          ethan: "-",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 1479,
          jeff: 22,
          ethan: "-",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 467,
          jeff: 12,
          ethan: "-",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 96,
          jeff: 18,
          ethan: "-",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
      ],
      "Retention Rate": [
        {
          date: "2024-12-08",
          yungtestworkspace4: 22.939068100358423,
          yungtestworkspace5: 24.27536231884058,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-09",
          yungtestworkspace4: 22.388059701492537,
          yungtestworkspace5: 20.306513409961685,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-10",
          yungtestworkspace4: 21.45748987854251,
          yungtestworkspace5: 25.882352941176475,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-11",
          yungtestworkspace4: 23.77358490566038,
          yungtestworkspace5: 20.481927710843372,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-12",
          yungtestworkspace4: 18.21428571428571,
          yungtestworkspace5: 25.984251968503933,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-13",
          yungtestworkspace4: 26.907630522088354,
          yungtestworkspace5: 25.691699604743086,
          yungtestworkspace3: 33.33333333333333,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-14",
          yungtestworkspace4: 17.46724890829694,
          yungtestworkspace5: 20.434782608695652,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-15",
          yungtestworkspace4: 24.894514767932492,
          yungtestworkspace5: 26.168224299065418,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-16",
          yungtestworkspace4: 22.709163346613543,
          yungtestworkspace5: 23.50597609561753,
          yungtestworkspace3: 50,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-17",
          yungtestworkspace4: 26.254826254826252,
          yungtestworkspace5: 22.64957264957265,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-18",
          yungtestworkspace4: 22.22222222222222,
          yungtestworkspace5: 25.210084033613445,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-19",
          yungtestworkspace4: 22.745098039215687,
          yungtestworkspace5: 20.577617328519857,
          yungtestworkspace3: 30.76923076923077,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2024-12-20",
          yungtestworkspace4: 20.833333333333336,
          yungtestworkspace5: 23.423423423423422,
          yungtestworkspace3: 0,
          jeff: 20,
          ethan: "-",
        },
        {
          date: "2024-12-21",
          yungtestworkspace4: 26.842105263157894,
          yungtestworkspace5: 22.727272727272727,
          yungtestworkspace3: 4.761904761904762,
          jeff: 4.761904761904762,
          ethan: "-",
        },
        {
          date: "2024-12-22",
          yungtestworkspace4: 33.02752293577982,
          yungtestworkspace5: 25.38860103626943,
          yungtestworkspace3: 7.954545454545454,
          jeff: 10,
          ethan: "-",
        },
        {
          date: "2024-12-23",
          yungtestworkspace4: 19.011406844106464,
          yungtestworkspace5: 23.076923076923077,
          yungtestworkspace3: 4.10958904109589,
          jeff: 3.3333333333333335,
          ethan: "-",
        },
        {
          date: "2024-12-24",
          yungtestworkspace4: 21.074380165289256,
          yungtestworkspace5: 28.125,
          yungtestworkspace3: 9.345794392523365,
          jeff: 9.090909090909092,
          ethan: "-",
        },
        {
          date: "2024-12-25",
          yungtestworkspace4: 25.738396624472575,
          yungtestworkspace5: 18.11320754716981,
          yungtestworkspace3: 13.333333333333334,
          jeff: 9.01639344262295,
          ethan: "-",
        },
        {
          date: "2024-12-26",
          yungtestworkspace4: 14.336917562724013,
          yungtestworkspace5: 23.17596566523605,
          yungtestworkspace3: 8.627450980392156,
          jeff: 11.170212765957446,
          ethan: "-",
        },
        {
          date: "2024-12-27",
          yungtestworkspace4: 22.325581395348838,
          yungtestworkspace5: 18.53932584269663,
          yungtestworkspace3: 7.834101382488479,
          jeff: 5.847953216374268,
          ethan: "-",
        },
        {
          date: "2024-12-28",
          yungtestworkspace4: 17.880794701986755,
          yungtestworkspace5: 27.205882352941174,
          yungtestworkspace3: 7.6923076923076925,
          jeff: 4.545454545454546,
          ethan: "-",
        },
        {
          date: "2024-12-29",
          yungtestworkspace4: 20.422535211267608,
          yungtestworkspace5: 14.880952380952381,
          yungtestworkspace3: 2.312138728323699,
          jeff: 3.0927835051546393,
          ethan: "-",
        },
        {
          date: "2024-12-30",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0.7042253521126761,
          jeff: 1.25,
          ethan: "-",
        },
        {
          date: "2024-12-31",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 2.1121039805036554,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-01",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0.5952380952380952,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-02",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-03",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-04",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-05",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
        {
          date: "2025-01-06",
          yungtestworkspace4: 0,
          yungtestworkspace5: 0,
          yungtestworkspace3: 0,
          jeff: 0,
          ethan: "-",
        },
      ],
    },
  },
  tableData: [
    {
      _id: "67765e47b05b20a142f104b0",
      entityName: "morphgranttrackingdashboardtest1231",
      activeWalletOnChain: "-",
      activeWalletOnWebsite: 1,
      activeWalletOnWebsiteGrowthRate: "-",
      transactionCount: "-",
      transactionCountGrowthRate: "-",
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 2,
      sessionsFromFootprintsGrowthRate: "-",
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: 2,
      sessionCountGrowthRate: "-",
      websiteTrafficWalletCount: 1,
      websiteTrafficWalletCountGrowthRate: "-",
      websiteTrafficRetentionRate: 0,
      websiteTrafficRetentionGrowthRate: null,
      dAppWalletCount: "-",
      dAppWalletCountGrowthRate: "-",
      dAppRetentionRate: "-",
      dAppRetentionRateGrowthRate: "-",
    },
    {
      _id: "676a97ea052dad8c9febbe93",
      entityName: "yungtestworkspace5",
      activeWalletOnChain: 1087,
      activeWalletOnWebsite: 64,
      activeWalletOnWebsiteGrowthRate: -48.38709677419355,
      transactionCount: 2345,
      transactionCountGrowthRate: -55.54502369668246,
      newDiscordMember: 149,
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: 173,
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 73,
      sessionsFromFootprintsGrowthRate: -47.85714285714286,
      engagementRate: 0.8011628693124196,
      engagementGrowthRate: "-",
      communityRetentionRate: 68.98197614419084,
      communityRetentionGrowthRate: -0.3569959139781572,
      sessionCount: 73,
      sessionCountGrowthRate: -47.85714285714286,
      websiteTrafficWalletCount: 64,
      websiteTrafficWalletCountGrowthRate: -48.38709677419355,
      websiteTrafficRetentionRate: 16.759259259259263,
      websiteTrafficRetentionGrowthRate: 21.534772182254212,
      dAppWalletCount: 1087,
      dAppWalletCountGrowthRate: -16.768759571209802,
      dAppRetentionRate: 21.67338896483267,
      dAppRetentionRateGrowthRate: -8.38618260042561,
    },
    {
      _id: "6705e4c1c36ea5e9fba25f57",
      entityName: "yungtestworkspace4",
      activeWalletOnChain: 1103,
      activeWalletOnWebsite: 63,
      activeWalletOnWebsiteGrowthRate: -49.6,
      transactionCount: 2389,
      transactionCountGrowthRate: -56.28545288197622,
      newDiscordMember: 193,
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: 302,
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 71,
      sessionsFromFootprintsGrowthRate: -49.645390070921984,
      engagementRate: 0.7838210835486039,
      engagementGrowthRate: "-",
      communityRetentionRate: 69.69271250899374,
      communityRetentionGrowthRate: -0.4401964426836229,
      sessionCount: 71,
      sessionCountGrowthRate: -49.645390070921984,
      websiteTrafficWalletCount: 63,
      websiteTrafficWalletCountGrowthRate: -49.6,
      websiteTrafficRetentionRate: 15.277777777777779,
      websiteTrafficRetentionGrowthRate: 11.756168359941933,
      dAppWalletCount: 1103,
      dAppWalletCountGrowthRate: -15.993907083015992,
      dAppRetentionRate: 20.296434276848174,
      dAppRetentionRateGrowthRate: -12.933661314408408,
    },
    {
      _id: "67049db39b7e1c1327b3d52c",
      entityName: "yungtestworkspace3",
      activeWalletOnChain: 3045,
      activeWalletOnWebsite: 29,
      activeWalletOnWebsiteGrowthRate: -74.10714285714286,
      transactionCount: 4124,
      transactionCountGrowthRate: 1042.3822714681442,
      newDiscordMember: 0,
      newDiscordMemberGrowthRate: 0,
      newTelegramMember: 0,
      newTelegramMemberGrowthRate: 0,
      sessionsFromFootprints: 29,
      sessionsFromFootprintsGrowthRate: -93.22429906542055,
      engagementRate: 0,
      engagementGrowthRate: "-",
      communityRetentionRate: 0,
      communityRetentionGrowthRate: null,
      sessionCount: 29,
      sessionCountGrowthRate: -93.22429906542055,
      websiteTrafficWalletCount: 29,
      websiteTrafficWalletCountGrowthRate: -74.10714285714286,
      websiteTrafficRetentionRate: 0,
      websiteTrafficRetentionGrowthRate: null,
      dAppWalletCount: 3045,
      dAppWalletCountGrowthRate: 1094.1176470588236,
      dAppRetentionRate: 5.839632659691461,
      dAppRetentionRateGrowthRate: -73.23900579479971,
    },
    {
      _id: "66cebfa17c822d33f26a474f",
      entityName: "ethan",
      activeWalletOnChain: "-",
      activeWalletOnWebsite: "-",
      activeWalletOnWebsiteGrowthRate: "-",
      transactionCount: "-",
      transactionCountGrowthRate: "-",
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: "-",
      sessionsFromFootprintsGrowthRate: "-",
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: "-",
      sessionCountGrowthRate: "-",
      websiteTrafficWalletCount: "-",
      websiteTrafficWalletCountGrowthRate: "-",
      websiteTrafficRetentionRate: "-",
      websiteTrafficRetentionGrowthRate: "-",
      dAppWalletCount: "-",
      dAppWalletCountGrowthRate: "-",
      dAppRetentionRate: "-",
      dAppRetentionRateGrowthRate: "-",
    },
    {
      _id: "668f90902f860c7321aa4cd0",
      entityName: "testautoassign",
      activeWalletOnChain: "-",
      activeWalletOnWebsite: "-",
      activeWalletOnWebsiteGrowthRate: "-",
      transactionCount: "-",
      transactionCountGrowthRate: "-",
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: "-",
      sessionsFromFootprintsGrowthRate: "-",
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: "-",
      sessionCountGrowthRate: "-",
      websiteTrafficWalletCount: "-",
      websiteTrafficWalletCountGrowthRate: "-",
      websiteTrafficRetentionRate: "-",
      websiteTrafficRetentionGrowthRate: "-",
      dAppWalletCount: "-",
      dAppWalletCountGrowthRate: "-",
      dAppRetentionRate: "-",
      dAppRetentionRateGrowthRate: "-",
    },
    {
      _id: "659e2421a68ca1205a0faafa",
      entityName: "jeff",
      activeWalletOnChain: 1100,
      activeWalletOnWebsite: 0,
      activeWalletOnWebsiteGrowthRate: -100,
      transactionCount: 1444,
      transactionCountGrowthRate: 652.0833333333333,
      newDiscordMember: "-",
      newDiscordMemberGrowthRate: "-",
      newTelegramMember: "-",
      newTelegramMemberGrowthRate: "-",
      sessionsFromFootprints: 0,
      sessionsFromFootprintsGrowthRate: -100,
      engagementRate: "-",
      engagementGrowthRate: "-",
      communityRetentionRate: "-",
      communityRetentionGrowthRate: "-",
      sessionCount: 0,
      sessionCountGrowthRate: -100,
      websiteTrafficWalletCount: 0,
      websiteTrafficWalletCountGrowthRate: -100,
      websiteTrafficRetentionRate: 0,
      websiteTrafficRetentionGrowthRate: null,
      dAppWalletCount: 1100,
      dAppWalletCountGrowthRate: 558.6826347305389,
      dAppRetentionRate: 6.287672366638993,
      dAppRetentionRateGrowthRate: -33.97944015029057,
    },
  ],
};

export default ecoscanMockData;
